module.exports = __webpack_public_path__ + "static/img/preview-03.24731f6e.webp";